import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M110,1920 L1809.93229,1920 L1809.93229,1806.67118 L110,1806.67118 L110,1920 Z M477.548028,1391.20773 L621.022313,1486.85725 L560.731381,1580.01354 L326.820698,1580.01354 L477.548028,1391.20773 Z M312.654595,1693.34236 L622.495588,1693.34236 L745.684015,1502.60996 L805.408302,1413.19352 C821.840981,1388.60117 850.513173,1375.56835 878.052076,1381.00813 C954.662358,1395.28757 1032.2926,1358.90901 1070.71107,1292.61166 L1645.96816,389.040977 C1686.31322,319.343753 1666.594,230.38063 1600.97662,186.409048 L1358.22628,24.5754933 C1292.49557,-18.9427734 1202.85247,-3.19006745 1154.68772,60.1607427 L488.540923,901.627228 C440.82949,964.411394 437.202968,1050.31464 479.587946,1115.13872 C494.887337,1138.82445 494.207364,1170.1032 477.888014,1194.80888 L419.637001,1282.07207 L229.471242,1520.51591 C203.632271,1552.81462 198.759131,1595.9929 216.665085,1633.16476 C234.571038,1670.22328 271.402905,1693.34236 312.654595,1693.34236 L312.654595,1693.34236 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconHighlighterSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconHighlighterSolid, _Component);

  var _super = _createSuper(IconHighlighterSolid);

  function IconHighlighterSolid() {
    _classCallCheck(this, IconHighlighterSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconHighlighterSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconHighlighter",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconHighlighterSolid.displayName = "IconHighlighterSolid";
  return IconHighlighterSolid;
}(Component);

IconHighlighterSolid.glyphName = 'highlighter';
IconHighlighterSolid.variant = 'Solid';
IconHighlighterSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconHighlighterSolid;
export { IconHighlighterSolid };